import React, { useContext, useEffect, useState } from 'react';
import { planes } from '../../data/cotizadorCrData';
import { estadoCivil, frecuenciaPagos, sexo } from '../../data/mochaData';
import http from '../../services/http';
import { endPoints, monedas, PLAN_AUTO_UNIFICADO } from '../../utils/constanst';
import DivRow from '../controls/DivRow';
import Input from '../controls/Input';
import InputSelect from '../controls/InputSelect';
import SwitchButton from '../controls/SwitchButton';
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import CustomSelect from '../controls/CustomSelect';
import { CotizadorNIDataContext } from '../../context/CotizadorNIDataContext';

const Step1 = () => {



    const { poliza, tarificacion, catalogos, setPoliza, setTarificacion, setCatalogos, polizaChangeHandler, tarificacionChangeHandler, init } = useContext(CotizadorNIDataContext);

    useEffect(() => {

        if (init) {
            cargarCatalogos(PLAN_AUTO_UNIFICADO);

        }
    }, [init]);



    const cargarCatalogos = async (planId) => {
        const [ marcas,  coberturas, usos, plan] = await Promise.all([
            http(endPoints.brands(planId)).get(),
            http(endPoints.coverages(planId)).get(),
            http(endPoints.vhUses).get(),
            http(endPoints.configPlan(1,planId)).get()
        ]);
        setCatalogos({ marcas,  coberturas, usos });
        setPoliza({ planesConfig: [plan] });
    }

    useEffect(() => {
        Promise.all([
            http(endPoints.brands(poliza.planId)).get(),
            http(endPoints.coverages(poliza.planId)).get()])
            .then(r => {
                setCatalogos({
                    marcas: r[0],                    
                    coberturas: r[1]
                });

            });
    }, [poliza.planId])

    useEffect(() => {
        if (poliza.planesConfig != null)
            setPoliza({ ...poliza, planConfig: poliza.planesConfig.find(x => poliza.planId) });

    }, [poliza.planId])

    useEffect(() => {
        if (tarificacion.marc != 0 && tarificacion.mode != 0 && tarificacion.anio != 0) {
            http(endPoints.datasheet(poliza.planId, tarificacion.marc, tarificacion.mode, tarificacion.anio)).get()
                .then(r => setTarificacion(r));
        }
    }, [tarificacion.anio]);


    const frecuenciaHandler = event => {
        let v = event.target.value;
        setPoliza({ [event.target.name]: v, frecuenciaPagos: v });
    }


    const marcaHandler = (event) => {
        setTarificacion({ [event.target.name]: event.target.value, mode: -1 });
        http(endPoints.models(poliza.planId, event.target.value)).get()
            .then(data => { setCatalogos({ modelos: data }); })
    }

    const modeloHandler = (event) => {
        tarificacionChangeHandler(event);
        http(endPoints.lastYear(poliza.planId, tarificacion.marc, event.target.value)).get()
            .then(data => { setCatalogos({ anios: data }); setTarificacion({ anio: 0 }); })

    }


    return (
        <div className="reponsive">

            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    <CustomSelect label='Sexo' field='sexo' value={poliza.sexo} catalog={sexo} onChange={polizaChangeHandler}/>
                    {/* <CustomSelect label='Actividad económica' containBlank={true} field='actividadEconomica' value={tarificacion.actividadEconomica}  onChange={tarificacionChangeHandler} info="" /> */}
                    <InputSelect containBlank={true} label='Actividad Economica' field='actividad' value={poliza.actividad} onChange={polizaChangeHandler} dataProvider='entities/0/economicActivities' />
                    
                    {/* <InputSelect label='Marca' field='marc' containBlank={true} value={tarificacion.marc} dataProvider={catalogos.marcas} onChange={marcaHandler} /> */}
                    <CustomSelect id="marca" label='Marca' field='marc' containBlank={true} value={tarificacion.marc} catalog={catalogos.marcas} onChange={marcaHandler} />

                    {/* <InputSelect label='Modelo' field='mode' containBlank={true} value={tarificacion.mode} dataProvider={catalogos.modelos} onChange={modeloHandler} /> */}
                    <CustomSelect id='modelo' label='Modelo' field='mode' containBlank={true} value={tarificacion.mode} catalog={catalogos.modelos} onChange={modeloHandler} />
                    <CustomSelect label='Año' field='anio' containBlank={true} value={tarificacion.anio} catalog={catalogos.anios} onChange={tarificacionChangeHandler} />
                    <SwitchButton label="Vehículo" si="Nuevo" no="Usado" value={tarificacion.auNuevo == 1} onClick={value => setTarificacion({ auNuevo: value ? 1 : 0 })} />
                </div>

            </div>
            <div className="reponsive-width-6">
                <div className="box-pl5-pr5">
                    <CustomSelect label='Estado Civil' field='estadoCivil' value={poliza.estadoCivil} catalog={estadoCivil} onChange={polizaChangeHandler}/>
                    <CustomSelect label='Frecuencia de pago' field='ncuotas' value={poliza.ncuotas} catalog={frecuenciaPagos} onChange={frecuenciaHandler} />
                    <Input type='text' label='Chasis' field='chasis' value={poliza.chasis}  onChange={polizaChangeHandler} />
                    <CustomSelect label='Uso del Vehículo' field='usoo' value={tarificacion.usoo} catalog={catalogos.usos} onChange={tarificacionChangeHandler} />
                    <Input type='number' label='Valor del Vehículo' field='valn' value={tarificacion.valn} onChange={tarificacionChangeHandler} info="Consiste en el valor de mercado de su Vehículo, excluyendo equipos especiales" />
                    
                    <Input type='text' label='Color' field='color' value={poliza.color} onChange={polizaChangeHandler} />
                   
                </div>
            </div>
            <ReactTooltip className='tipstyle' multiline={true} />
        </div>
    );
}

export default Step1;
